import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  select: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  deviceSpecificLabel: {
    marginBottom: "auto",
    marginTop: "20px"
  },
  deviceSpecificButton: {
    marginBottom: "auto"
  },
  overFlowEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default useStyles;
